<ng-container *ngIf="path">
    <svg [attr.width]="svgWidth" viewBox="0 0 400 200" xmlns="http://www.w3.org/2000/svg" version="1.1">
        <rect x="1" y="1" width="398" height="198" fill="none"></rect>
        <path id="signature" fill="none" stroke="black" stroke-width="3" [attr.d]="path">
        </path>
    </svg>
</ng-container>